<div class="bg-white m-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-end" aria-label="Close" (click)="accept()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-center text-secondary pb-2 pe-2">Attention</h3>
  </div>
  <div class="modal-body">
    <div class="row">
      <strong
        ><p class="col-12 text-secondary">{{ message }}</p></strong
      >
      <span class="form-control bg-white border-0 mb-0" readonly *ngFor="let beneficiary of beneficiariesNoMail">{{ beneficiary }}</span>
    </div>
    <div class="text-center pt-3">
      <button type="button" (click)="accept()" class="btn btn-primary w-50">OK</button>
    </div>
  </div>
</div>
